//Scroll functionality in category page
document.addEventListener("DOMContentLoaded", () => {
    const menuLinks = document.querySelectorAll('.custom-collection--heading');
    const collectionHeadings = document.querySelectorAll('.collection-category--main-heading');
    let scrolling = false; 
  
    const getOffset = () => (window.innerWidth <= 768 ? 64 : 280);
  
    if (menuLinks.length > 0) {
      menuLinks[0].classList.add('active');
    }
  
    menuLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        const targetId = this.getAttribute('href').substring(1); 
        const targetElement = document.getElementById(targetId);
  
        if (targetElement) {
          scrolling = true; 
          setTimeout(() => (scrolling = false), 800);
  
          const offset = getOffset();
          const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;
          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
  
          menuLinks.forEach(item => item.classList.remove('active'));
          this.classList.add('active');
        }
      });
    });
  
    const onScroll = () => {
      if (scrolling) return; 
  
      const offset = getOffset();
      const scrollPosition = window.scrollY + offset;
      const pageBottom = document.documentElement.scrollHeight - 10;
  
      let lastActiveIndex = -1;
  
      collectionHeadings.forEach((heading, index) => {
        const headingTop = heading.offsetTop; 
  
        if (scrollPosition >= headingTop) {
          lastActiveIndex = index;
          menuLinks.forEach(link => link.classList.remove('active'));
          menuLinks[index].classList.add('active');
        }
      });
  
      if (window.scrollY + window.innerHeight >= pageBottom - 10) {
        menuLinks.forEach(link => link.classList.remove('active'));
        menuLinks[menuLinks.length - 1].classList.add('active');
      }
    };
  
    window.addEventListener('scroll', onScroll);
  });

    document.addEventListener("DOMContentLoaded", function () {
        const header = document.querySelector(".header-wrapper");
        const collection = document.querySelector(".custom-collection-page--main");
      
        window.addEventListener("scroll", function () {
          const headerBottom = header.getBoundingClientRect().bottom;
      
          if (headerBottom <= -150) {
            collection.classList.add("sticky-top");
            collection.classList.remove("sticky");
          } else if (headerBottom <= 0) {
            collection.classList.add("sticky");
            collection.classList.remove("sticky-top");
          } else {
            collection.classList.remove("sticky");
            collection.classList.remove("sticky-top");
          }
        });
      });